module.exports = __webpack_public_path__ + "static/media/postman.fbfb57a1.svg";